export const APP_NAME = 'Guidroo';
export const APP_DESCRIPTION =
  'Guidroo is an all-in-one platform for mentors to host classes, manage students, and monetise courses through secure, scalable video and content tools.';
